import React from 'react';
import PropTypes from 'prop-types';
import Badge from '../Badge/index.js';
import s from './composeLabels.js';

const {
  shape,
  bool,
  string,
  number
} = PropTypes;
function ContentBadges({
  content,
  user,
  horizontal,
  labels
}) {
  const containerClassNames = horizontal ? "slds-grid" : "";
  const badgeClassNames = horizontal ? "slds-m-left_small" : "slds-m-bottom_small";
  const renderCredential = () => {
    if (!content.credential) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: badgeClassNames
    }, /*#__PURE__*/React.createElement(Badge, {
      label: s(labels.currency, {
        n: content.credential.price
      }),
      variant: "success"
    }));
  };
  const renderDueBadge = () => {
    if (!user || !user.assignment || !user.assignment.dueAt) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: badgeClassNames
    }, /*#__PURE__*/React.createElement(Badge, {
      iconLeft: {
        assistiveText: "",
        name: "clock"
      },
      label: s(labels.due, {
        date: user.assignment.dueAt
      }),
      variant: "danger"
    }));
  };
  const renderPoints = () => {
    if (!content.points) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: badgeClassNames
    }, /*#__PURE__*/React.createElement(Badge, {
      label: s(labels.points, {
        n: content.points
      })
    }));
  };
  let result;
  if (horizontal) {
    result = /*#__PURE__*/React.createElement("div", {
      className: containerClassNames
    }, renderCredential(), renderDueBadge(), renderPoints());
  } else {
    result = /*#__PURE__*/React.createElement("div", {
      className: containerClassNames
    }, renderPoints(), renderDueBadge(), renderCredential());
  }
  return result;
}
ContentBadges.defaultProps = {
  user: null,
  horizontal: false
};
ContentBadges.propTypes = {
  labels: shape({
    points: string,
    currency: string,
    due: string
  }).isRequired,
  content: shape({
    points: string,
    credential: shape({
      price: number.isRequired
    })
  }).isRequired,
  user: shape({
    assignment: shape({
      dueAt: string.isRequired
    })
  }),
  horizontal: bool
};

export { ContentBadges as default };
